import { george, observer, pr, React, RouteComponentProps, ui } from "aaa";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import { GdsFakeActionButtonContainer } from "components/common/GdsFakeActionButtonContainer";
import { themeColors } from "muiTheme";
import { useEffect } from "react";
import { pushRoute } from "stores/RouterFunctions";
import { TeamcardLinkageRoutes } from "./TeamcardLinkageRoutes";
import { TeamcardLinkageStore } from "./TeamcardLinkageStore";
import "./CustomButton.css";


type IProps = RouteComponentProps<{}> & {
    store: TeamcardLinkageStore
};

const DetailContainer = ({ grey, children }: { grey?: boolean; children: React.ReactNode }) => {
    let backgroundColor: string | undefined = ui.isDarkMode ? "black" : themeColors.grey_100;
    if (!grey) {
        backgroundColor = undefined;
    }

    return <div style={{ backgroundColor, padding: "8px 8px" }}>
        {children}
    </div>
}


export const TeamcardLinkageLandingPage = observer((props: IProps) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const buttonIsLoading = props.store.isLoading;

    const onSubmit = async () => {
        try {
            pushRoute(TeamcardLinkageRoutes.EMAIL);
        } catch (error) {
            pushRoute("/error");
        }
    };

    if (props.store.isLoading) {
        return <george.LoadingIndicator isLoading height={ui.windowHeight} />;
    }

    return (
        <george.Card
            elevated={false}
            style={{ borderRadius: 8 }}
        >
            <div style={{ padding: "16px 16px" }}>
                <pr.P_22_TITLE style={{ fontWeight: 700, lineHeight: "28px" }}>
                    {ui.__("teamcardLinkage.landingPage.headline")}
                </pr.P_22_TITLE>

                <div style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}>
                    <div style={{ maxWidth: 400, textAlign: "center" }}>
                        <img
                            src={"https://www.sparkasse.at/business-virtualcard"}
                            width="90%"
                            alt="business virtual card"
                        />
                    </div>

                </div>

                <DetailContainer>
                    <pr.P_14_CONTENT style={{ fontWeight: "bold" }}>
                        {ui.__("teamcardLinkage.company")}
                    </pr.P_14_CONTENT>
                    <pr.P_16_CONTENT style={{ marginTop: 8 }}>
                        {props.store.invitationData?.card.company.name}
                    </pr.P_16_CONTENT>
                </DetailContainer>
                <DetailContainer grey>
                    <pr.P_14_CONTENT style={{ fontWeight: "bold" }}>
                        {ui.__("teamcardLinkage.cardHolder")}
                    </pr.P_14_CONTENT>
                    <pr.P_16_CONTENT style={{ marginTop: 8 }}>
                        {props.store.invitationData?.card.cardHolderName}
                    </pr.P_16_CONTENT>
                </DetailContainer>
                <DetailContainer>
                    <pr.P_14_CONTENT style={{ fontWeight: "bold" }}>
                        {ui.__("teamcardLinkage.cardProduct")}
                    </pr.P_14_CONTENT>
                    <pr.P_16_CONTENT style={{ marginTop: 8 }}>
                        {props.store.invitationData?.card.product}
                    </pr.P_16_CONTENT>
                </DetailContainer>
            </div>
            <pr.LightSeparatorLine />
            <GdsFakeActionButtonContainer>
                <GdsFakeActionButton
                    className="custom-linkage-gds-button"
                    isLoading={buttonIsLoading}
                    color="primary"
                    onClick={onSubmit}
                // fullWidth={externalInterfaceStore.isGeorgeApp}
                >
                    {ui.__("teamcardLinkage.button.linkNow")}
                </GdsFakeActionButton>
                {/* <GdsFakeActionButton
                    onClick={() => {
                        externalInterfaceStore.raiseExitSuccess()
                    }}
                    fullWidth={externalInterfaceStore.isGeorgeApp}
                >
                    {ui.__("common.cancel")}
                </GdsFakeActionButton> */}
            </GdsFakeActionButtonContainer>
        </george.Card >
    );
});



// WEBPACK FOOTER //
// ./src/components/teamcardLinkage/TeamcardLinkageLandingPage.tsx